import { get } from '../utils/axios'

export const getTypesAPI = async (onlyId = []) => {
  return await get('emps/types', { onlyId })
}